import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { fadeInOutAnimation } from '@app/core/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'rk-publishing-step-panel',
  imports: [FontAwesomeModule, MatExpansionModule, TranslatePipe],
  animations: [fadeInOutAnimation],
  templateUrl: './publishing-step-panel.component.html',
  styleUrl: './publishing-step-panel.component.scss',
})
export class PublishingStepPanelComponent {
  @Input()
  name?: string;
  @Input()
  tag?: string;
  @Input()
  collapsable? = true;
  @Input()
  isOpen = true;
  @Output() readonly toggleStep = new EventEmitter<void>();

  toggleContent(): void {
    this.isOpen = !this.isOpen;
    this.toggleStep.emit();
  }
}
